import React, { FC } from 'react';

import Detail from '../components/Detail';
import { normalizeFontAwesomeIRI } from '../lib/iris';
import { EventResource } from '../models';

const EVENT_TYPES = {
  other_event: 'Overig',
  flyer_event: 'Flyeren',
  slot_event: 'Eindsprint',
  canvas_event: 'Huis-aan-huizen',
  meeting_event: 'Bijeenkomst',
};

const EventTypeDetail: FC<{ event: EventResource }> = ({ event }) => {
  const image = event.attributes.image;
  const name = EVENT_TYPES[event.attributes.eventType as keyof typeof EVENT_TYPES];

  return <Detail icon={image && normalizeFontAwesomeIRI(image)} text={name} />;
};

export default EventTypeDetail;
